import { render, staticRenderFns } from "./GamificacaoTab.vue?vue&type=template&id=e9efcc2c&scoped=true"
import script from "./GamificacaoTab.vue?vue&type=script&lang=js"
export * from "./GamificacaoTab.vue?vue&type=script&lang=js"
import style0 from "./GamificacaoTab.vue?vue&type=style&index=0&id=e9efcc2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9efcc2c",
  null
  
)

export default component.exports